import React, { createElement, Fragment, useMemo } from "react"

export function URLView({ url: path }: { url: string }) {
  const elements = useMemo(() => {
    try {
      const url = new URL(path)
      const { searchParams } = url
      const base = url.origin + url.pathname

      const parts: React.ReactNode[] = [
        <span className="url-base" key="base">
          {base}
        </span>,
      ]

      if (!searchParams.size) {
        return parts
      }

      parts.push(<span css="opacity-40">?</span>)

      let i = 0
      for (const [rawKey, rawValue] of searchParams.entries()) {
        const encodedValue = encodeURIComponent(rawValue)
        parts.push(
          <span css="text-[light-dark(#881280,#5db0d7)]">
            {encodeURIComponent(rawKey)}
          </span>,
          <span css="opacity-40">=</span>,
          <span
            css="text-[light-dark(#c41a16,#e93f3b)]"
            title={encodedValue !== rawValue ? rawValue : undefined}
          >
            {encodedValue}
          </span>
        )

        if (i++ < searchParams.size - 1) {
          parts.push(<span css="opacity-40">&</span>)
        }
      }

      return parts
    } catch {
      // Invalid URL fallback
      return [
        <span className="url-invalid" key="invalid">
          {path}
        </span>,
      ]
    }
  }, [path])

  return <span data-testid="url">{createElement(Fragment, null, ...elements)}</span>
}
